import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from "user/components/common/Header";
import OrderItem from "./-components/OrderItem";
import { useGetOrder } from "common/hooks/user/order/useGetOrder";
import { enum_api_uri } from "common/hooks/utils/enum";
import Spinner from "common/components/spinner";
import { formatDeliveryTime, formatDeliveryTimeFromDate } from "common/hooks/utils/utils";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchIcon.svg";
import { ReactComponent as Empty } from "../../../common/assets/icons/empty.svg";
import { ReactComponent as PaginationPrev } from "../../assets/icons/rightArrow.svg";
import { ReactComponent as PaginationNext } from "../../assets/icons/rightArrow.svg";

export default function Orders() {
    const navigate = useNavigate();
    const [searchtxt, setSearchtxt] = useState("");
    const [page, setPage] = useState(1);
    const { data: listData, isPending } = useGetOrder(page, "recipient_name", searchtxt);
    // console.log("listData", listData);

    return (
        <div className="min-h-[100dvh] flex flex-col">
            {isPending && <Spinner />}
            <div className="sticky top-0 bg-white">
                <Header onClickClose={() => navigate("/")} title="주문내역" />
                <div className="wrapper py-[8px]">
                    <div className="flex items-center bg-[#F3F3F8] rounded-[8px] py-[8px] px-[12px]">
                        <input
                            type="text"
                            value={searchtxt}
                            placeholder="받으시는 분을 검색하세요"
                            className="bg-transparent flex-1 placeholder:text-[#999999] focus:outline-none"
                            onChange={e => setSearchtxt(e.target.value)}
                        />
                        <SearchIcon />
                    </div>
                </div>
            </div>
            {listData?.data_list.length === 0 && (
                <div className="bg-white flex-1 flex">
                    <div className="flex-1 flex flex-col gap-[40px] justify-center items-center">
                        <Empty />
                        <div className="flex flex-col gap-[8px] items-center justify-center">
                            <p className="text-[#273219] text-[20px] leading-[30px] font-[500] text-center">
                                주문내역이 없습니다. <br /> 신규주문을 신청해보세요!
                            </p>
                            <Link to="/new-order" className="p-[12px] rounded-[12px] bg-[#F2F6EF] text-[#4B632B] leading-[24px] font-[500]">
                                주문신청하기
                            </Link>
                        </div>
                    </div>
                </div>
            )}
            {listData && listData.data_list.length > 0 && (
                <div className="wrapper flex-1 bg-[#F2F6EF] py-[12px] flex flex-col">
                    <div className="flex-1 flex flex-col gap-[12px]">
                        {listData?.data_list.map(data => {
                            const imgSrc = data.product_info.product_image?.file_name;
                            const date = data.recipient_info.delivery_date;
                            const orderDateFull = data.order_date_full; // 즉시 배송일때 설정된 시간
                            const deliveryTime = orderDateFull ?? "";
                            const specificTime = data.recipient_info.delivery_time
                                ? formatDeliveryTime(data.recipient_info.delivery_time)
                                : ""; // 즉시 배송이 아닐 때 설정한 시간
                            const time = data.delivery_immediate
                                ? "즉시배송" + " " + `(${formatDeliveryTimeFromDate(deliveryTime)})`
                                : specificTime;

                            return (
                                <div
                                    key={data.order_idx}
                                    className="bg-white rounded-[16px] cursor-pointer"
                                    onClick={() => navigate(`/orders/${data.order_idx}`)}
                                >
                                    <OrderItem
                                        orderDate={data.order_date}
                                        status={data.status_info.order_status_text}
                                        productImg={imgSrc ? enum_api_uri.api_uri + "/" + imgSrc : ""}
                                        productCategory={data.product_info.product_category}
                                        productName={data.product_info.product_name}
                                        deliveryDate={date + " " + time}
                                        deliveryAddress={
                                            data.recipient_info.delivery_address + " " + (data.recipient_info.delivery_address_detail ?? "")
                                        }
                                        recipientName={data.recipient_info.recipient_name}
                                    />
                                </div>
                            );
                        })}
                    </div>

                    <div className="mt-[40px]">
                        <Pagination
                            activePage={page}
                            totalItemsCount={listData?.total_count}
                            itemsCountPerPage={10}
                            onChange={(page: number) => setPage(page)}
                            innerClass="flex justify-center items-center h-[24px] gap-[12px]" // ul 스타일
                            itemClass="text-[#484964] w-[24px] font-[700] text-[14px] leading-[24px] items-center " // li 스타일
                            activeLinkClass="rounded-[5px] text-[#4B632B]"
                            linkClass="flex justify-center"
                            itemClassPrev="ml-[4px] mr-[10px]"
                            itemClassNext="mr-[4px] ml-[10px]"
                            itemClassFirst="hidden"
                            itemClassLast="hidden"
                            prevPageText={<PaginationPrev className="rotate-[180deg] [&_path]:stroke-black" />}
                            nextPageText={<PaginationNext className="[&_path]:stroke-black" />}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
